import { Fancybox } from '@fancyapps/ui';
import domReady from '@wordpress/dom-ready';

import '@fancyapps/ui/dist/fancybox/fancybox.css';

domReady(() => {
  Fancybox.bind('[data-fancybox]', {});
});
